import styled from "@emotion/styled";

export const DivItemWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const AnchorItem = styled.a`
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  line-height: 44px;
  font-size: 14px;
  margin-right: 5px;
`;

export const SpanText = styled.span<{ margin?: string }>`
  ${({ margin }) => margin && `margin: ${margin};`}
`;
